import React, { useEffect, useState } from "react";
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { Permission } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { PermissionItem } from "../PermissionItem";

const permissionController = new Permission();

export function ListPermission(props) {
  const { section, reload, onReload } = props;
  const [permissions, setPermissions] = useState(null);
  const { accessToken } = useAuth();

  /**
   * useEffect hook to fetch permissions when the component mounts or when `reload` or `accessToken` changes.
   *
   * This effect sets the permissions to null initially, then asynchronously fetches the permissions
   * using the `permissionController.getPermissions` method with the provided `accessToken`.
   * If the fetch is successful, it updates the permissions state with the response.
   * If there is an error during the fetch, it logs the error to the console.
   *
   * @param {boolean} reload - A boolean value that triggers the effect when changed.
   * @param {string} accessToken - The access token used to authenticate the request.
   */
  useEffect(() => {
    (async () => {
      try {
        setPermissions(null);
        const response = await permissionController.getPermissions(section);
        setPermissions(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [section, reload, accessToken]);

  if (!permissions) return <Loader active inline="centered" />;
  if (size(permissions) === 0) return "No existen permisos registrados";

  return map(permissions, (permission) => (
    <PermissionItem
      key={permission.id}
      permission={permission}
      onReload={onReload}
    />
  ));
}
